var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWheelDozer = function SvgWheelDozer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14830_3029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.72 -43.6108H-143.107V157.114H362.72V-43.6108Z",
    stroke: "black",
    strokeWidth: 3.12581
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.295 60.4188H23.4743C21.821 60.4188 20.4766 59.0744 20.4766 57.4224V43.2142C20.4766 41.5622 21.821 40.2178 23.4743 40.2178H27.295C28.947 40.2178 30.2915 41.5622 30.2915 43.2142V57.4224C30.2915 59.0744 28.947 60.4188 27.295 60.4188Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.338 0H17.8084C16.7042 0 15.8105 0.894949 15.8105 1.99783V9.24964C15.8105 10.1352 16.3859 10.8848 17.1839 11.1459V29.8632C17.1839 31.1605 18.2357 32.2102 19.531 32.2102H22.7575C23.4816 32.2102 24.1282 31.8832 24.5582 31.3678L26.2559 31.606V32.145C24.7836 32.254 23.6222 33.48 23.6222 34.9812V38.7232L22.2017 40.5185C21.8047 41.0218 21.5894 41.6436 21.5894 42.2835V58.0899C21.5894 58.8913 21.9258 59.6423 22.4951 60.1732C22.4278 60.4147 22.3901 60.6684 22.3901 60.9315V65.9123C22.3901 68.7001 24.1659 71.708 27.0331 71.708H33.8092C34.6914 71.708 35.4995 71.3009 36.0291 70.6408C36.5587 71.3002 37.3655 71.708 38.249 71.708H45.025C47.8929 71.708 49.668 68.6994 49.668 65.9123V60.9315C49.668 60.7081 49.6391 60.4928 49.5907 60.2835C50.8093 59.9027 51.6961 58.7641 51.6961 57.4224V43.2141C51.6961 42.0487 51.0259 41.0393 50.0523 40.5434C49.95 40.396 49.8356 40.2554 49.7037 40.1269L48.3169 38.7656V34.9819C48.3169 33.5507 47.2591 32.3704 45.8843 32.1692V31.6107L47.6271 31.3664C48.0585 31.8792 48.7024 32.2062 49.4251 32.2062H52.6503C53.9477 32.2062 54.9974 31.1545 54.9974 29.8591V11.1331C55.7766 10.8612 56.3351 10.121 56.3351 9.24964V1.99783C56.3358 0.894949 55.4422 0 54.338 0ZM36.0291 64.5981L34.108 61.5176H37.9509L36.0291 64.5981ZM32.7992 14.906V12.5563C32.7992 12.0873 32.6666 11.6445 32.4378 11.2475H38.9575C38.7119 11.6445 38.5713 12.0873 38.5713 12.5563V14.906H32.7992Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0386 17.7529H29.1035V35.4562H43.0386V17.7529Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 1.76191
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8111 11.6982H32.3359V36.1735H39.8111V11.6982Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.06667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9976 26.7658C28.9976 27.3162 28.5508 27.7643 27.999 27.7643H24.1783C23.6265 27.7643 23.1797 27.3162 23.1797 26.7658V12.5562C23.1797 12.0058 23.6265 11.5576 24.1783 11.5576H27.999C28.5508 11.5576 28.9976 12.0058 28.9976 12.5562V26.7658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0006 19.6772H26.0702L24.6914 20.3656V28.5131L29.0006 29.116V19.6772Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.06667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1777 26.7658C43.1777 27.3162 43.6245 27.7643 44.1763 27.7643H47.997C48.5488 27.7643 48.9956 27.3162 48.9956 26.7658V12.5562C48.9956 12.0058 48.5488 11.5576 47.997 11.5576H44.1763C43.6245 11.5576 43.1777 12.0058 43.1777 12.5562V26.7658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2925 57.4221C28.2925 57.9739 27.8457 58.4207 27.2939 58.4207H23.4732C22.9214 58.4207 22.4746 57.9739 22.4746 57.4221V43.2139C22.4746 42.6621 22.9214 42.2153 23.4732 42.2153H27.2939C27.8457 42.2153 28.2925 42.6621 28.2925 43.2139V57.4221Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8809 57.4221C43.8809 57.9739 44.3276 58.4207 44.8794 58.4207H48.7001C49.2519 58.4207 49.6987 57.9739 49.6987 57.4221V43.2139C49.6987 42.6621 49.2519 42.2153 48.7001 42.2153H44.8794C44.3276 42.2153 43.8809 42.6621 43.8809 43.2139V57.4221Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1719 19.6772H46.1037L47.4824 20.3656V28.5131L43.1719 29.116V19.6772Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.06667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6687 31.1934H31.3047V32.9927H40.6687V31.1934Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4703 34.981H45.4709V39.9597L47.7117 42.1581L47.6693 57.9644L46.592 58.6703H25.5572L24.4375 58.0896V42.2832L26.4703 39.7108V34.981Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.06667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3197 67.2342L33.811 68.8599C33.811 68.8599 28.0846 68.8599 27.0349 68.8599C25.9832 68.8599 25.2383 67.2342 25.2383 65.9119C25.2383 64.591 25.2383 60.9312 25.2383 60.9312H30.3886L34.3197 67.2342Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 1.06667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7422 67.2342L38.2509 68.8599C38.2509 68.8599 43.9772 68.8599 45.027 68.8599C46.0767 68.8599 46.8223 67.2342 46.8223 65.9119C46.8223 64.591 46.8223 60.9312 46.8223 60.9312H41.6733L37.7422 67.2342Z",
    fill: "#C68106",
    stroke: "black",
    strokeWidth: 1.06667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3926 65.7333L31.6172 67.0966H40.7761L41.7551 65.6983V45.21L30.4632 45.8741L30.3926 65.7333Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.40952
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5189 65.2998H41.6096V65.6376L40.6796 67.0002H31.6386L30.4785 65.6914L30.5189 65.2998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0447 58.9855C36.872 58.9855 37.5426 58.3149 37.5426 57.4876C37.5426 56.6604 36.872 55.9897 36.0447 55.9897C35.2175 55.9897 34.5469 56.6604 34.5469 57.4876C34.5469 58.3149 35.2175 58.9855 36.0447 58.9855Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0443 54.6692C37.5282 54.6692 38.7312 53.4662 38.7312 51.9823C38.7312 50.4984 37.5282 49.2954 36.0443 49.2954C34.5604 49.2954 33.3574 50.4984 33.3574 51.9823C33.3574 53.4662 34.5604 54.6692 36.0443 54.6692Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0948 32.353H40.0195L40.7584 31.5825L43.7743 33.2203V43.9699L43.0375 47.0174L40.0525 47.0504L39.4745 46.4078L32.5443 46.3445L31.9031 46.9528L29.3676 47.0174L28.373 43.7122V33.3166L31.3244 31.6801L32.0948 32.353Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.06667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3382 1.99805H17.8086V9.24986H54.3382V1.99805Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7597 9.19043H19.5332V29.8638H22.7597V9.19043Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.06667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.651 9.19043H49.4258V29.8585H52.651V9.19043Z",
    fill: "#F9BA15",
    stroke: "black",
    strokeWidth: 1.06667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5822 8.20068H39.2324V15.6591H41.5822V8.20068Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0066 8.20068H30.6582V15.6591H33.0066V8.20068Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14830_3029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.3738,
    height: 72,
    fill: "white",
    transform: "translate(15.8125)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWheelDozer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "wheel-dozer.1407f90abbf35281536305e64736a490.svg";